import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IPackageParams, IPackageResponse, IPackageState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchUpdatePackage = createAsyncThunk(
  'listPackages/fetchUpdatePackage',
  async ({ id, params }: { id: string; params: IPackageParams }, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.updatePackage(id, params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IPackageState = {
  isLoading: false,
  response: null,
  error: null
}

const updatePackageSlice = createSlice({
  name: 'packages/update',
  initialState,
  reducers: {
    resetUpdatePackage: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchUpdatePackage.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchUpdatePackage.fulfilled, (state, action: PayloadAction<IPackageResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchUpdatePackage.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default updatePackageSlice.reducer
export const { resetUpdatePackage } = updatePackageSlice.actions
